export class UserInfoResultDto {
    userId: string;
    displayName: string;
    companyName: string;
    companyId: number;
    isInternal: boolean;
    isShadowLogin: boolean;
    isPortalAdmin: boolean;
    primaryBusinessRole: string;
    primaryDepartmentId: number;
    memberOfDepartmentIdCSV: string;
    canInvoiceOwner: boolean;
    email: string;
    token: string;
    profileImage: string;
    canImpersonate: boolean;
    memberOfDepartmentIds: Array<number>;
    canManageUserProfile: boolean;
}
